module.exports = __webpack_public_path__ + "static/media/Pyke.e2e62970.png";